import React from "react";

import SlateEditor from "../components/SlateEditor/SlateEditor";

export default function Home() {
	return (
		<>
			<SlateEditor />
		</>
	);
}
